export default __webpack_public_path__ + "static/illu_standout-664b538d2293065aa7f8c67292572d55.png";